import type { Messages } from '../catalogue.en'

/**
 * The Control Center's Connected modules section. Composed into the public
 * catalogue by `catalogue.ru.ts`; nothing imports this module directly.
 */
export const controlCenterModules: Partial<Messages> = {
  "clinicModules.title": "Модули клиники",
  'clinicModules.subtitle':
    'Встроенные модули, зарегистрированные в этой установке, и состояние каждого из них в этой клинике: включён, выключен или скрыт.',
  'clinicModules.loading': 'Загрузка подключённых модулей',
  'clinicModules.loadFailed': 'Не удалось загрузить каталог модулей.',
  'clinicModules.loadForbidden': 'Этой учётной записи не разрешено просматривать каталог модулей.',
  'clinicModules.forbidden': 'Вам не разрешено просматривать каталог модулей этой клиники',
  'clinicModules.listLabel': 'Зарегистрированные модули',
  'clinicModules.empty': 'Нет доступных модулей',
  'clinicModules.emptyDetail':
    'Для этой организации нет доступных модулей.',
  'clinicModules.readOnly': 'Вы можете видеть состояние каждого модуля, но не менять его.',
  'clinicModules.readOnlyItem': 'Сервер не разрешает этой учётной записи менять этот модуль.',
  'clinicModules.column.module': 'Модуль',
  'clinicModules.column.controls': 'Доступность',
  'clinicModules.backToModules': 'Назад к модулям',
  'clinicModules.notFoundTitle': 'Модуль не найден',
  'clinicModules.notFound': 'Этот модуль недоступен для организации.',

  'clinicModules.views.label': 'Разделы {name}',
  'clinicModules.views.title': 'Титульный лист',
  'clinicModules.views.titleDescription': 'Идентификация, состояние и границы модуля',
  'clinicModules.views.settings': 'Настройки',
  'clinicModules.views.settingsDescription': 'Доступность и настройка интеграции',
  'clinicModules.views.debug': 'Дебаг',
  'clinicModules.views.debugDescription': 'Подготовленные проверки интерфейса',
  'clinicModules.titleSheet.subtitle': 'Сведения о зарегистрированном модуле',
  'clinicModules.titleSheet.identity': 'Идентификация модуля',
  'clinicModules.titleSheet.lifecycle': 'Жизненный цикл',
  'clinicModules.titleSheet.effect': 'Действие состояния',
  'clinicModules.titleSheet.boundaries': 'Зависимости и исходящие действия',
  'clinicModules.settings.title': 'Настройки {name}',
  'clinicModules.settings.subtitle': 'Общеклиническая доступность модуля и настройка интеграции.',
  'clinicModules.settings.lifecycle': 'Доступность',
  'clinicModules.debug.unavailableTitle': 'Дебаг недоступен',
  'clinicModules.debug.unavailable': 'Эта сборка или учётная запись не предлагает отладочные действия для модуля.',

  'clinicModules.code': 'Код модуля',
  'clinicModules.version': 'Версия',
  'clinicModules.build': 'Сборка',
  'clinicModules.dependsOn': 'Использует службы ядра',
  'clinicModules.dependsOnNone': 'Не объявлены',
  'clinicModules.egress': 'Исходящие действия',
  'clinicModules.egressNone': 'Не объявлены',
  'clinicModules.egress.ai': 'ИИ',
  'clinicModules.egress.communications': 'Коммуникации',
  'clinicModules.egress.patient_message': 'Сообщения пациентам',
  'clinicModules.egress.outbound_http': 'Исходящие HTTP-запросы',
  'clinicModules.egress.notification': 'Уведомления',
  'clinicModules.egress.background_dispatch': 'Фоновые задания',
  'clinicModules.lastChange': 'Последнее изменение',
  'clinicModules.lastChangeNever': 'В этой клинике никогда не менялось',
  'clinicModules.lastChangeBy.account': '{when}, учётной записью',
  'clinicModules.lastChangeBy.integration': '{when}, интеграцией',
  'clinicModules.lastChangeBy.unrecognized': '{when}',
  'clinicModules.changedWhen': 'Изменено',

  'clinicModules.status': 'Состояние',
  'clinicModules.status.enabled': 'Включён',
  'clinicModules.status.disabled': 'Выключен',
  'clinicModules.status.hidden': 'Скрыт',
  'clinicModules.statusDetail.enabled':
    'Полностью активен и виден. Его входящие запросы, команды, фоновая работа и исходящие вызовы выполняются.',
  'clinicModules.statusDetail.disabled':
    'Виден, но остановлен. Сохранённые данные модуля остаются доступными для чтения; ни один новый входящий запрос, команда, фоновое задание или исходящий вызов не выполняется.',
  'clinicModules.statusDetail.hidden':
    'Остановлен и убран со всех обычных экранов. Его показывает только этот каталог. Сохранённые данные модуля остаются.',

  'clinicModules.health': 'Конфигурация',
  'clinicModules.health.ready': 'Готова',
  'clinicModules.health.configuration_required': 'Требуется настройка',
  'clinicModules.health.unavailable': 'Не удаётся проверить',
  'clinicModules.health.unknown': 'Не сообщается',
  'clinicModules.health.unrecognized': 'Нераспознанный статус',
  'clinicModules.healthDetail.ready': 'Локальная конфигурация полна.',
  'clinicModules.healthDetail.configuration_required':
    'Заполните настройки, необходимые для нужной операции. Включение модуля само по себе не заполняет его настройки.',
  'clinicModules.healthDetail.unavailable':
    'Не удалось определить состояние локальной конфигурации. Для этого ни с чем за пределами этой установки связь не устанавливалась.',
  'clinicModules.healthDetail.unknown': 'Модуль не сообщает состояние конфигурации.',
  'clinicModules.healthDetail.unrecognized':
    'Сервер сообщил состояние конфигурации, неизвестное этой версии рабочего пространства. Показанное состояние — по-прежнему серверное.',
  'clinicModules.healthIssues': 'Сообщённые проблемы',

  'clinicModules.switchEnabled': 'Включён',
  'clinicModules.switchHidden': 'Скрыт',
  'clinicModules.switchOn': 'Вкл',
  'clinicModules.switchOff': 'Выкл',
  'clinicModules.switchEnabledOn': 'Включён: да',
  'clinicModules.switchEnabledOff': 'Включён: нет',
  'clinicModules.switchHiddenOn': 'Скрыт: да',
  'clinicModules.switchHiddenOff': 'Скрыт: нет',
  'clinicModules.action.enable': 'Включить',
  'clinicModules.action.disable': 'Выключить',
  'clinicModules.action.hide': 'Скрыть',
  'clinicModules.action.unhide': 'Показать снова',
  'clinicModules.switchEnabledHint':
    'Вкл: модуль работает. Выкл: сохранённые данные остаются доступными для чтения, каждое новое действие останавливается.',
  'clinicModules.switchHiddenHint':
    'Вкл: также выключает модуль и убирает его со всех обычных экранов. Выкл: модуль снова показывается, но остаётся выключенным.',
  'clinicModules.enableUnavailable':
    'Скрытый модуль нельзя включить. Сначала выключите «Скрыт»; он останется выключенным, пока его не включат отдельным шагом.',
  'clinicModules.pending': 'Сохранение изменения…',
  'clinicModules.saved': 'Изменение сохранено. Сервер подтвердил новое состояние (редакция {revision}).',
  'clinicModules.savedListStale':
    'Изменение сохранено и подтверждено сервером (редакция {revision}). Остальной список обновить не удалось, он может быть устаревшим.',
  'clinicModules.stateChangedElsewhere':
    'Кто-то другой изменил этот модуль, пока вы принимали решение. Вы ничего не изменили; показано текущее состояние на сервере. Выберите заново, если изменение всё ещё нужно.',

  'clinicModules.confirm.enableTitle': 'Включить {name}?',
  'clinicModules.confirm.enableDescription':
    'Модуль начинает принимать входящие запросы, выполнять команды и фоновую работу и делать объявленные им исходящие вызовы. Он не получает доступа, которого у учётной записи ещё нет.',
  'clinicModules.confirm.enable': 'Включить',
  'clinicModules.confirm.disableTitle': 'Выключить {name}?',
  'clinicModules.confirm.disableDescription':
    'Сохранённые данные модуля остаются доступными для чтения, ничего не удаляется. Новые входящие запросы, команды, фоновые задания, вызовы ИИ, сообщения и любые другие действия, которые начинает модуль, отклоняются, пока его снова не включат.',
  'clinicModules.confirm.disable': 'Выключить',
  'clinicModules.confirm.hideTitle': 'Скрыть {name}?',
  'clinicModules.confirm.hideDescription':
    'Скрытие тем же шагом выключает модуль. Его пункты навигации, блоки на панели, значки пациентов, источники, разделы карты и записи ленты исчезают со всех обычных экранов.',
  'clinicModules.confirm.hideRetained':
    'Сохранённые данные модуля остаются. Клинические записи, сообщения пациентам и записи аудита, уже зафиксированные клиникой, остаются ровно такими, какие они есть. Только разработчик видит его в каталоге и может снова открыть доступ организации.',
  'clinicModules.confirm.hide': 'Скрыть и выключить',
  'clinicModules.confirm.unhideTitle': 'Снова показать {name}?',
  'clinicModules.confirm.unhideDescription':
    'Модуль возвращается на обычные экраны, но остаётся выключенным. Включение — отдельный шаг, который делается после.',
  'clinicModules.confirm.unhide': 'Показать снова',
  'clinicModules.confirm.cancel': 'Оставить как есть',
  'clinicModules.confirm.retry': 'Повторить',

  'clinicModules.reason.legend': 'Причина',
  'clinicModules.reason.hint': 'Записывается вместе с изменением в журнал аудита клиники.',
  'clinicModules.reason.other': 'Другое',
  'clinicModules.reason.detail': 'Подробности причины',
  'clinicModules.reason.rollout': 'Внедрение в этой клинике',
  'clinicModules.reason.maintenance': 'Обслуживание',
  'clinicModules.reason.maintenanceDone': 'Обслуживание завершено',
  'clinicModules.reason.configuration': 'Настройка не завершена',
  'clinicModules.reason.notUsed': 'Не используется в этой клинике',
  'clinicModules.reason.postponed': 'Внедрение отложено',

  'clinicModules.error.concurrent':
    'Кто-то другой изменил этот модуль раньше. Вы ничего не изменили; теперь показано текущее состояние.',
  'clinicModules.error.hiddenCannotEnable':
    'Модуль скрыт, и его нельзя включить. Ничего не изменено; сначала выключите «Скрыт».',
  'clinicModules.error.forbidden':
    'Этой учётной записи больше не разрешено менять состояние модулей. Ничего не изменено.',
  'clinicModules.error.invalid': 'Сервер отклонил изменение как недопустимое. Ничего не изменено.',
  'clinicModules.error.notFound': 'Этот модуль недоступен для организации. Ничего не изменено.',
  'clinicModules.error.unavailable':
    'Не удалось связаться с сервером. Ничего не изменено; попробуйте ещё раз.',
  'clinicModules.error.malformed':
    'Сервер ответил, но его ответ не удалось прочитать. Перезагрузите список, чтобы увидеть, применено ли изменение.',
  'clinicModules.error.failed': 'Не удалось сохранить изменение. Ничего не изменено.',
}
